<template>
      <div class="casino-navigation">
        <li v-for="(navGroup, gIndex) in navigationItems" :key="gIndex" :class="['navigation-group', navGroup.layout]" v-if="!(mobileBigAndBelow && navGroup.cssClass === 'popular-desktop') && navigationItems && !isMobile">
         <div
          class="nav-slider-body"
          :id="'nav-body-' + gIndex"
          >
          <button v-if="isScroll && showPrev && !mobileBigAndBelow" :id="'prev-btn-' + gIndex"
             class="prev-btn casino-slider-btn" @click="slide(gIndex, 'prev')">
            <v-icon>arrow_back_ios</v-icon>
          </button>
          <ul class="navigation"
            :id="'nav-list-' + gIndex"
            :data-nav-list-id="gIndex"
          >
            <li class="navigation-item" v-for="(item, index) in navGroup.nodes"
                @click="setChildren(item)"
                :key="index">
              <router-link v-if="['INTERNAL', 'GROUP'].includes(item.linkType)" :to="{ path: '/' + $i18n.locale + item.uri || '/' }" :id="item.id">
                <icon v-if="item.cssClass && item.cssClass !=='default'" :name="item.cssClass"></icon>
                <span>{{ item.text }}</span>
              </router-link>
              <a :href="item.uri" v-else-if="item.linkType === 'URL'" :class="item.cssClass" :setTarget="setExternalNavigationTarget(`casino-nav-item-${item.id}`, item.target)" :id="'casino-nav-item-' + item.id" :rel="'external'" :aria-label="item.text">
                <icon v-if="item.cssClass && item.cssClass !=='default'" :name="item.cssClass"></icon>
                <span class="item-text">{{ item.text }}</span>
              </a>
            </li>
          </ul>
          <button v-if="isScroll && showNext && !mobileBigAndBelow" :id="'next-btn-' + gIndex"
            class="next-btn casino-slider-btn" @click="slide(gIndex, 'next')">
          <v-icon>arrow_forward_ios</v-icon>
        </button>
        </div>
        </li>
        <div v-if="isMobile" :class="['sport','section']" v-for="(item, index) in navigationItems[0].nodes" :key="index" @click="setChildren(item)">
<!--          navigationItems = {{item}}-->
          <router-link v-if="['INTERNAL', 'GROUP'].includes(item.linkType)" :to="{ path: '/' + $i18n.locale + item.uri || '/' }">
            <icon v-if="item.cssClass && item.cssClass !=='default'" :name="item.cssClass" color-name="white"></icon>
            <span class="mobile-menu-text">{{item.text}}</span>
          </router-link>
          <router-link v-else-if="item.linkType === 'URL'" :to="{ path: '/' + $i18n.locale + item.uri || '/' }" :setTarget="setExternalNavigationTarget(`casino-nav-item-${item.id}`, item.target)" :id="'casino-nav-item-' + item.id" :rel="'external'">
            <icon v-if="item.cssClass && item.cssClass !=='default'" :name="item.cssClass" color-name="white"></icon>
            <span class="mobile-menu-text">{{item.text}}</span>
          </router-link>
        </div>
        <casino-sub-navigation v-if="activeChildren.length > 0" :children="activeChildren"></casino-sub-navigation>
      </div>
</template>
<script>
import Screen from '@/components/mixins/Screen'
import Icon from '@/components/common/Icon'
import CasinoSubNavigation from '@/components/igaming/partials/casinoSubNavigation'
import Casino from '@/components/mixins/Casino'

export default {
  name: 'casinoNavigation',
  props: [
    'navigationItems',
    'isMobile'
  ],
  mixins: [
    Screen,
    Casino
  ],
  components: {
    Icon,
    CasinoSubNavigation
  },
  data () {
    return {
      activeChildren: [],
      isScroll: true,
      showPrev: false,
      showNext: true,
      resizeTimeout: null
    }
  },
  computed: {},
  methods: {
    setChildren (item) {
      if (item.nodes && item.nodes.length) {
        this.activeChildren = item.nodes
      } else {
        this.activeChildren = []
      }
    },
    setChildrenFromRoute () {
      const current = this.$route.path.replace(`/${this.$i18n.locale}`, '')
      const parents = this.navigationItems[0].nodes
      for (const parent of parents) {
        if (!parent.nodes) continue
        const isParent = current === parent.uri
        if (isParent) {
          this.activeChildren = parent.nodes
          return
        }
        const isChildMatch = parent.nodes.find(child => child.uri === current)
        if (isChildMatch) {
          this.activeChildren = parent.nodes
          return
        }
      }
      this.activeChildren = []
    },
    slide (groupId, direction) {
      const container = document.getElementById(`nav-list-${groupId}`)
      if (!container) return

      if (direction === 'next') this.showPrev = true
      const delta = direction === 'prev' ? -200 : 200
      const target = container.scrollLeft + delta
      container.scrollTo({ left: target, top: 0, behavior: 'smooth' })

      const { isAtLeft, isAtRight } = this.checkHorizontalScroll(container, target)
      setTimeout(() => {
        this.showPrev = !isAtLeft
        this.showNext = !isAtRight
      }, 0)
    },
    checkHorizontalScroll (el, target) {
      const isAtLeft = target <= 0
      const isAtRight = target + el.clientWidth >= el.scrollWidth
      return { isAtLeft, isAtRight }
    },
    resetAll () {
      this.isScroll = true
      this.showPrev = false
      this.showNext = true
    },
    isScrollElement (groupId) {
      let navListElement = document.getElementById('nav-list-' + groupId)
      let navBodyElement = document.getElementById('nav-body-' + groupId)

      if (!navListElement || !navBodyElement) {
        return false
      }

      let isScroll = navListElement.scrollWidth > navBodyElement.clientWidth

      if (!isScroll) {
        this.isScroll = false
        return false
      }
      return true
    },
    handleResize () {
      let anyScroll = false
      this.navigationItems.forEach((navGroup, gIndex) => {
        try {
          if (this.isScrollElement(gIndex)) {
            anyScroll = true
          }
        } catch (e) {
          console.error('Error checking scroll for navigation group', gIndex, e)
        }
      })
      this.isScroll = anyScroll
    }
  },
  mounted () {
    this.setChildrenFromRoute()
    this.$nextTick(() => {
      this.handleResize()

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout)
        this.resizeTimeout = setTimeout(() => {
          this.handleResize()
        }, 250)
      })
    })
  },
  destroy () {
    clearTimeout(this.resizeTimeout)
    window.removeEventListener('resize', this.handleResize)
    this.resetAll()
  }
}
</script>
<style scoped lang="stylus"> 
.casino-slider-btn
  background: var(--casiono-slider-btn-bgr)
  border-radius: 50%
  cursor: pointer
  z-index: 1
  position: absolute
  top: 50%
  transform translate(0px, 10px)
  margin-top: -25px
  width: 32px
  height: 32px
  display: flex
  align-items: center
  justify-content: center
  opacity: 0.33
  transition opacity 0.3s ease
  &:hover
    opacity: 1
  .v-icon
    font-size 20px
    width 15px
    color: var(--casiono-slider-btn-color)
  &.prev-btn
    left: -15px
  &.next-btn
    right: -15px
</style>


// WEBPACK FOOTER //
// src/components/igaming/partials/casinoNavigation.vue